import { X } from 'lucide-react';
import { Agent } from '../../../types/agent';

interface AgentDetailModalProps {
  agent: Agent;
  onSelect: (agent: Agent) => void;
  onClose: () => void;
}

export const AgentDetailModal = ({ agent, onSelect, onClose }: AgentDetailModalProps) => (
  <>
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40" onClick={onClose} />
    <div
      className="fixed inset-x-4 top-1/2 -translate-y-1/2 max-w-md mx-auto z-50 bg-[#1a1a1a] rounded-2xl border border-[#333333] shadow-2xl"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center justify-between p-4 border-b border-[#333333]">
        <h3 className="text-white font-semibold">Detalhes do Agente</h3>
        <button onClick={onClose} className="p-2 text-[#888888] hover:text-white rounded-lg hover:bg-white/5">
          <X size={20} />
        </button>
      </div>
      <div className="p-6">
        <h2 className="text-[#F4CC04] text-xl font-semibold mb-3">{agent.name}</h2>
        <p className="text-[#CCCCCC] text-sm leading-relaxed mb-4">
          {agent.description || 'Nenhuma descrição disponível para este agente.'}
        </p>
        {agent.tags && agent.tags.length > 0 && (
          <div className="mb-6">
            <h4 className="text-white text-sm font-medium mb-2">Tags:</h4>
            <div className="flex flex-wrap gap-2">
              {agent.tags.map((tag) => (
                <span key={tag.id} className="px-3 py-1 bg-[#2a2a2a] text-[#CCCCCC] text-sm rounded-full">
                  {tag.name}
                </span>
              ))}
            </div>
          </div>
        )}
        <button
          onClick={() => onSelect(agent)}
          className="w-full py-3 bg-[#F4CC04] text-black rounded-lg font-semibold hover:bg-[#d4b104] transition-colors"
        >
          Selecionar este agente
        </button>
      </div>
    </div>
  </>
);
